import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {CallService} from "../../../../service/api/call.service";
import {CallResultEnum} from "../../../../enum/call-result-enum.enum";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {Sorting} from "../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'pc-statistics',
    templateUrl: 'pc-statistics.component.html',
    standalone: false
})
export class PcStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    // busyCalls: number = 0;
    // no_answerCalls: number = 0;
    // no_timeCalls: number = 0;
    // successCalls: number = 0;


    callHistoryWidget: WidgetData;
    callTypeWidget: WidgetData;
    callAgentWidget: WidgetData;
    recentCallsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        protected callService: CallService,
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'Call Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.getTotalCalls();
        this.refreshCallHistoryWidget();
        this.refreshCallTypeWidget();
        this.refreshCallAgentWidget();
        this.refreshRecentCallsWidget();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/pc/config']);
    }

    getTotalCalls() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['callResult'],
            [new ObjectRequestListAttribute('callResult', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.callService.groupBy(objectRequestList).subscribe(res => {

            // for (let entry of res.entries) {
            //     if (entry['callResult'] == CallResultEnum.busy) {
            //         this.busyCalls = entry['callResult_count'];
            //     } else if (entry['callResult'] == CallResultEnum.no_answer) {
            //         this.no_answerCalls = entry['callResult_count'];
            //     } else if (entry['callResult'] == CallResultEnum.no_time) {
            //         this.no_timeCalls = entry['callResult_count'];
            //     } else if (entry['callResult'] == CallResultEnum.success) {
            //         this.successCalls = entry['callResult_count'];
            //     }
            // }

            this.overviewDto = [
                {label: 'Busy', value: 0 },
                {label: 'No answer', value: 0 },
                {label: 'No time', value: 0 },
                {label: 'No connection', value: 0 }, // TM-1000001509: added Kein Anschluss in overview chart
                {label: 'Success', value: 0 }
            ];

            for (let entry of res.entries) {
                if (entry['callResult'] === CallResultEnum.busy) {
                    // this.overviewDto.push({label: 'Busy', value: entry['callResult_count'] })
                    this.overviewDto.find(item => item.label === 'Busy').value = entry['callResult_count'];
                } else if (entry['callResult'] === CallResultEnum.no_answer) {
                    this.overviewDto.find(item => item.label === 'No answer').value = entry['callResult_count'];
                } else if (entry['callResult'] === CallResultEnum.no_time) {
                    this.overviewDto.find(item => item.label === 'No time').value = entry['callResult_count'];
                } else if (entry['callResult'] === CallResultEnum.no_connection) {
                    // TM-1000001509: count Kein Anschluss
                    this.overviewDto.find(item => item.label === 'No connection').value = entry['callResult_count'];
                } else if (entry['callResult'] === CallResultEnum.success) {
                    this.overviewDto.find(item => item.label === 'Success').value = entry['callResult_count'];
                }
            }


        });
    }

    refreshCallHistoryWidget() {
        this.callHistoryWidget = WidgetFactory.createWidget(
            'pc.overview.call.history.widget',
            'Registrierungshistorie',
            'history.chart',
            'list',
            'entity.groupBy',
            'pc.Call',
            WidgetDataParam.create("fieldCategory", "callType"),
            WidgetDataParam.create("fieldCategoryCount", "callType_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.callHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["callType", "createdDate"],
            [new ObjectRequestListAttribute("callType", "Type", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshCallTypeWidget() {
        this.callTypeWidget = WidgetFactory.createWidgetGroupBy(
            'pc.overview.call.type.widget',
            'Call Type',
            'category',
            'entity.groupBy',
            'pc.Call',
            'callType',
            'callType_count',
            this.filterCriteria,
            'callType',
            'Anzahl');
    }

    refreshCallAgentWidget() {
        this.callAgentWidget = WidgetFactory.createWidgetGroupBy(
            'pc.overview.call.agents.widget',
            'Call Agents',
            'category',
            'entity.groupBy',
            'pc.Call',
            'agent',
            'agent_count',
            this.filterCriteria,
            'agent',
            'Anzahl');
    }

    refreshRecentCallsWidget() {
        this.recentCallsWidget = WidgetFactory.createWidgetTableEntityBasicQl('pc.overview.recently.calls', 'Recent Calls', 'pc.Call', this.filterCriteriaForQuery ?? [], [new Sorting('e.createdDate', false)]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
